export class RemindCampaign {
    constructor(remindCampaign) {
        this.content    = remindCampaign.content;
        this.after_date = remindCampaign.after_date;
        this.expired_in = remindCampaign.expired_in;
    }
}